import { initializeApp } from "firebase/app";
import {
  getAuth,
  connectAuthEmulator,
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
} from "firebase/auth";
import { getStorage, connectStorageEmulator } from "firebase/storage";

/**
 * Firebase client initialisation.
 *
 * Only Auth and Storage are used from the browser. Firestore is deliberately
 * absent: every read and write goes through the Cloud Functions API so that role
 * checks, validation and audit logging happen in one place. Firestore rules deny
 * all client access, so importing the SDK here would only add bundle weight and
 * invite someone to try.
 */

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const app = initializeApp(config);
export const auth = getAuth(app);
export const storage = getStorage(app);

if (process.env.REACT_APP_USE_EMULATORS === "true") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectStorageEmulator(storage, "127.0.0.1", 9199);
}

/**
 * Apply the "remember me" choice.
 *
 * Local persistence survives closing the browser; session persistence does not.
 * Unticked is the safer default for an admin console on a shared machine, so it
 * is the value the login form starts with.
 */
export function applyPersistence(remember) {
  return setPersistence(
    auth,
    remember ? browserLocalPersistence : browserSessionPersistence
  );
}

export const STORAGE_BUCKET = config.storageBucket;
